module.exports = __webpack_public_path__ + "img/4.b3800b55.png";